<template>
   Currency: USD
  <div class="price-section">

    
    <PriceCard
      v-for="plan in defaultPlans"
      :key="plan.name"
      :entries="plan"
      :planTerm="planTerm"
      :currentPlanTerm="currentPlanTerm"
      :isLanding="isLanding"
      @plan_clicked="planClickedHandler"
    />

    <!-- @to-contact-us="() => $emit('to-contact-us')" -->
  </div>
</template>

<script>
import PriceCard from '@/components/subscription/PriceCard.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useToast } from 'vue-toast-notification';

const $toast = useToast();

export default {

  components: {
    PriceCard,
  },
  props: {
      //     planTerms: [
      //   { value: 'short', display: "Short Term" },
      //   { value: 'year', display: "Save by choosing annual plan" },
      // ],
    currentPlan: {
      type: String,
      default: "",
    },
    recommended: {
      type: String,
      default: "team",
    },
    planTerm: {
      type: String,
      default: "month",
    },
    currentPlanTerm: {
      type: String,
      default: "month",
    },
    isLanding: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['plan_clicked'],
  data() {
    return {
      defaultPlans: [],
      plans: [],
    };
  },
  watch: {
    currentPlan() {
      this.processPlans(this.plans);
    },
    planTerm() {
      this.processPlans(this.plans);
    },
  },
  mounted() {
    this.getPlans();
  },
  methods: {
    planClickedHandler(plan) {
      this.$emit('plan_clicked', plan);
    },
    kv(k,v,t) {
      if (v<0) {
       v='Unlimited';
      }
      if (t=='s') v=this.sformat(v);
      if (t=='q') v=this.qformat(v);
      v=v.toString();
      return {k,v}
    },
    sformat(v) {
      if (v >= 1e12) {
        return Math.floor(v / 1e12) + "TB";
      }
      if (v >= 1e9) {
        return Math.floor(v / 1e9) + "GB";
      }
      if (v >= 1e6) {
        return Math.floor(v / 1e6) + "MB";
      }
      if (v >= 1e3) {
        return Math.floor(v / 1e3) + "KB";
      }
      if (v >= 0) {
        return Math.floor(v / 1e3) + "B";
      }
      return v + "";
    },
    qformat(v) {
      if (v >= 1e6) {
        return Math.floor(v / 1e6) + "M";
      }
      if (v >= 1e3) {
        return Math.floor(v / 1e3) + "K";
      }
      return v.toString();
    },
    processPlans(plans) {
      this.defaultPlans = [];
      var e={}
      plans.forEach((plan, index, array) => {

        let offers=[];
        
        offers.push(this.kv('Active Users',plan['users'],''));
        offers.push(this.kv('Image Storage',plan['images'],'q'));
        offers.push(this.kv('Projects',plan['projects'],''));
        offers.push(this.kv('Datasets',plan['datasets'],''));
        offers.push(this.kv('Total Storage',plan['storage'],'s'));

        if (plan['offers']) {
          Object.entries(plan['offers']).forEach(([key, value]) => {
            offers.push(this.kv( key, value ));
          });
        }
        
      
        const p = {
          name: plan.name,
          title: plan.description,
          // bkColor: "#9b8a2f",
          buttonText: `Get ${plan.title}`,
          isCurrent: false,
          recommended: false,
          features: plan.features,
          shortTerm: "",
        };
        if (plan.daily > 0) {
          p.shortTerm = "/day";
          p.priceShortTerm = plan.daily;
        }
        if (plan.weekly > 0) {
          p.shortTerm = "/week";
          p.priceShortTerm = plan.weekly;
        }
        if (plan.monthly > 0) {
          p.shortTerm = "/month";
          p.priceShortTerm = plan.monthly;
        }
        if (plan.yearly > 0) {
          p.price = plan.yearly;
        }

        if (plan.name === "free") {
          p.shortTerm = "FREE";
          if (this.isLanding) p.buttonText = "Try for Free";
        }
        if (p.price === undefined) {
          p.price = p.priceShortTerm;
        }
        if (plan.name === this.currentPlan) {
          p.isCurrent = true;
          if (this.planTerm === this.currentPlanTerm) {
            p.buttonText = "Your Current Plan";
            p.isDisabled = true;
          } else {
            p.buttonText = "Change Plan Term";
          }
        }

        p.offers=offers;

        this.defaultPlans[index] = p;
      });
    },
    async getPlans() {
      this.loading = true;
      const dsConn = new DatastoreConnect();
      let showHidden = false;
      await dsConn.listPlans({ show_hidden: showHidden })
        .then((data) => {
          this.loading = false;
          if (data.result) {
            this.plans = data.result;
            this.processPlans(this.plans);
          } else {
            throw new Error(data.error.message);
          }
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `${e}`,
            type: "error",
            position: "top",
          });
        });
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.price-section {
 display: flex;
 gap: 30px;
 flex-direction: row;
 flex-wrap: wrap;

}

@media (max-width: 1200px) {
  .price-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: $breakpoint-md) {
  .price-section {
     display: flex;
  }
}

</style>
